import {
  PathologyOrderCreateRequest,
  PathologyOrderGetAllParams,
  PathologyOrderGetAllResponse,
  PathologyOrderGetResponseWithId,
} from '@quromedical/models';
import { PathologyTestSearchResult } from '@quromedical/pathology';
import { trpc } from 'trpc';

export enum PathologyEndpoint {
  Ampath = 'ampath',
}

interface PathologyTestSearchParams {
  query?: string;
  specialOrder?: boolean;
  commonOnly?: boolean;
  limit?: number;
}

export class PathologyApi {
  getPathologyOrders = async (
    params: PathologyOrderGetAllParams
  ): Promise<PathologyOrderGetAllResponse> => trpc.client.pathologyRequest.getAll.query(params);

  searchAmpathTests = async (
    params: PathologyTestSearchParams
  ): Promise<PathologyTestSearchResult[]> => {
    return await trpc.client.pathologyRequest.searchTests.query(params);
  };

  public async createAmpathRequest(
    req: PathologyOrderCreateRequest
  ): Promise<PathologyOrderGetResponseWithId> {
    return await trpc.client.patient.createPathologyRequest.mutate(req);
  }
}
